(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-products-list"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mili-b2b-registration"] && !Shopify.designMode) return;
  try {
    
  /**
   * Digital Ocean Function Configuration
   * Using the deployed wholesale application function
   */
  const DO_FUNCTION_CONFIG = {
    endpoint: 'https://faas-tor1-70ca848e.doserverless.co/api/v1/web/fn-d01249d8-4966-44ec-b3f5-9e4d4805b1dc/b2b/registration',
  };

  /**
   * Phone number formatting function
   */
  function formatPhoneNumber(value) {
    if (!value) return value;

    // Remove all non-digit characters
    const phoneNumber = value.replace(/[^\d]/g, '');

    // Format based on length
    if (phoneNumber.length < 4) {
      return phoneNumber;
    } else if (phoneNumber.length < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    } else {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    }
  }

  /**
   * Show success message
   */
  function showSuccessMessage(message) {
    const successDiv = document.getElementById('b2b-success-message');
    const errorDiv = document.getElementById('b2b-error-message');
    const loadingDiv = document.getElementById('b2b-loading');
    const formContent = document.getElementById('b2b-form-content');

    if (message) {
      successDiv.querySelector('p').textContent = message;
    }

    errorDiv.style.display = 'none';
    loadingDiv.style.display = 'none';
    formContent.style.display = 'none';
    successDiv.style.display = 'flex';
    successDiv.focus();

    // Scroll to top
    successDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /**
   * Show error message
   */
  function showErrorMessage(message) {
    const successDiv = document.getElementById('b2b-success-message');
    const errorDiv = document.getElementById('b2b-error-message');
    const loadingDiv = document.getElementById('b2b-loading');
    const formContent = document.getElementById('b2b-form-content');
    const submitButton = document.querySelector('.b2b-registration-submit-button');

    document.getElementById('b2b-error-text').textContent = message;

    successDiv.style.display = 'none';
    loadingDiv.style.display = 'none';
    formContent.style.display = 'block';
    errorDiv.style.display = 'flex';
    submitButton.disabled = false;
    submitButton.textContent = 'Submit Application';

    errorDiv.focus();
    errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /**
   * Show loading state
   */
  function showLoadingState() {
    const successDiv = document.getElementById('b2b-success-message');
    const errorDiv = document.getElementById('b2b-error-message');
    const loadingDiv = document.getElementById('b2b-loading');
    const submitButton = document.querySelector('.b2b-registration-submit-button');

    successDiv.style.display = 'none';
    errorDiv.style.display = 'none';
    loadingDiv.style.display = 'flex';
    submitButton.disabled = true;
    submitButton.textContent = 'Processing...';

    loadingDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /**
   * Collect and format form data for Digital Ocean function
   */
  function collectFormData(form) {
    const formData = new FormData(form);
    const data = {
      // Form metadata
      form_type: 'wholesale_application',
      form_id: formData.get('form_id'),
      submitted_at: new Date().toISOString(),

      // How they learned about ARTFIL
      learn_source: formData.getAll('learn_source[]'),
      learn_source_other: formData.get('learn_source_other') || '',

      // Company type
      company_type: formData.get('company_type') || '',
      company_type_other: formData.get('company_type_other') || '',

      // Company information
      company_name: formData.get('company_name') || '',
      address: formData.get('address') || '',
      city: formData.get('city') || '',
      province: formData.get('province') || '',
      postal_code: formData.get('postal_code') || '',
      country: formData.get('country') || '',
      address_type: formData.get('address_type') || '',
      website: formData.get('website') || '',
      business_number: formData.get('business_number') || '',

      // Contact information
      contact_name: formData.get('contact_name') || '',
      telephone: formData.get('telephone') || '',
      email: formData.get('email') || '',

      // Billing information
      billing_different: formData.get('billing_different') === '1',
      billing_address: formData.get('billing_address') || '',
      billing_city: formData.get('billing_city') || '',
      billing_province: formData.get('billing_province') || '',
      billing_postal: formData.get('billing_postal') || '',
      billing_country: formData.get('billing_country') || '',
    };

    return data;
  }

  /**
   * Validate form data
   */
  function validateFormData(data) {
    const errors = [];

    // Required fields
    if (!data.email || !data.email.trim()) errors.push('Email is required');
    if (!data.company_name || !data.company_name.trim()) errors.push('Company name is required');
    if (!data.contact_name || !data.contact_name.trim()) errors.push('Contact name is required');
    if (!data.telephone || !data.telephone.trim()) errors.push('Telephone is required');
    if (!data.address || !data.address.trim()) errors.push('Address is required');
    if (!data.city || !data.city.trim()) errors.push('City is required');
    if (!data.province || !data.province.trim()) errors.push('Province/State is required');
    if (!data.postal_code || !data.postal_code.trim()) errors.push('Postal code is required');
    if (!data.country || !data.country.trim()) errors.push('Country is required');

    // Email format validation
    if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.push('Please enter a valid email address');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }

  /**
   * Send data to Digital Ocean Function
   */
  async function sendToDigitalOceanFunction(data) {
    try {
      console.log('Sending data to Digital Ocean Function:', data);

      const response = await fetch(DO_FUNCTION_CONFIG.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const result = await response.json();
      console.log('Digital Ocean Function Response:', result);
      return result;

    } catch (error) {
      console.error('Error calling Digital Ocean Function:', error);
      // Store form data locally as backup
      localStorage.setItem('wholesale_application_backup', JSON.stringify({
        data: data,
        error: error.message,
        timestamp: new Date().toISOString()
      }));
      throw error;
    }
  }

  /**
   * Initialize form functionality on page load
   */
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.b2b-registration-form');
    const phoneInput = document.getElementById('B2BRegistration-telephone');
    const billingDifferentCheckbox = document.getElementById('billing-different');
    const billingFields = document.getElementById('billing-fields');

    // Phone number formatting
    if (phoneInput) {
      phoneInput.addEventListener('input', function(e) {
        const formattedNumber = formatPhoneNumber(e.target.value);
        e.target.value = formattedNumber;
      });

      // Format initial value if present
      if (phoneInput.value) {
        phoneInput.value = formatPhoneNumber(phoneInput.value);
      }
    }

    // Billing address toggle
    if (billingDifferentCheckbox && billingFields) {
      billingDifferentCheckbox.addEventListener('change', function() {
        if (this.checked) {
          billingFields.style.display = 'block';
          billingFields.classList.add('show');
        } else {
          billingFields.style.display = 'none';
          billingFields.classList.remove('show');
          // Clear billing fields when hidden
          const billingInputs = billingFields.querySelectorAll('input, select');
          billingInputs.forEach(input => input.value = '');
        }
      });

      // Check initial state
      if (billingDifferentCheckbox.checked) {
        billingFields.style.display = 'block';
        billingFields.classList.add('show');
      }
    }

    // Form submission handler - COMPLETE REPLACEMENT OF SHOPIFY FORM
    if (form) {
      form.addEventListener('submit', async function(e) {
        e.preventDefault(); // CRITICAL: Prevent default form submission

        try {
          // Show loading state
          showLoadingState();

          // Collect form data
          const formData = collectFormData(form);

          // Validate form data
          const validation = validateFormData(formData);
          if (!validation.isValid) {
            showErrorMessage('Please fix the following errors: ' + validation.errors.join(', '));
            return;
          }

          // Send to Digital Ocean Function
          const result = await sendToDigitalOceanFunction(formData);

          if (result.success) {
            // Show success message
            showSuccessMessage(result.message || 'Thank you for your wholesale application. We will review your application and contact you within 2-3 business days.');

            // Clear form data from localStorage
            localStorage.removeItem('wholesale_application_autosave');
            localStorage.removeItem('wholesale_application_backup');

            // Reset form
            form.reset();

          } else {
            // Show error from function
            showErrorMessage(result.error || 'There was an error processing your application. Please try again.');
          }

        } catch (error) {
          console.error('Error submitting form:', error);
          showErrorMessage('Unable to submit your application at this time. Please try again or contact us directly at contact@artfil.ca');
        }
      });
    }

    // Auto-save functionality (optional)
    const autoSaveInputs = form?.querySelectorAll('input, select, textarea');
    if (autoSaveInputs) {
      autoSaveInputs.forEach(input => {
        input.addEventListener('change', function() {
          try {
            const autoSaveData = collectFormData(form);
            localStorage.setItem('wholesale_application_autosave', JSON.stringify({
              data: autoSaveData,
              timestamp: new Date().toISOString()
            }));
          } catch (error) {
            console.error('Auto-save error:', error);
          }
        });
      });

      // Restore from autosave on page load (optional)
      const autosaved = localStorage.getItem('wholesale_application_autosave');
      if (autosaved && form) {
        try {
          const savedData = JSON.parse(autosaved);
          console.log('Autosaved data available:', savedData);
          // You could implement restoration logic here if needed
        } catch (error) {
          console.error('Error parsing autosaved data:', error);
        }
      }
    }
  });

  // Expose utilities for debugging
  window.wholesaleApp = {
    collectFormData,
    sendToDigitalOceanFunction,
    formatPhoneNumber,
    validateFormData,
    showSuccessMessage,
    showErrorMessage,
    showLoadingState,
    config: DO_FUNCTION_CONFIG
  };

  } catch(e) { console.error(e); }
})();
})();
